import {
  Zap, Wrench, Code2, Sparkles, Bug, Gauge, ShieldCheck,
  CalendarDays, MessageCircle,
} from "lucide-react";

const MAP = { Zap, Wrench, Code2, Sparkles, Bug, Gauge, ShieldCheck, CalendarDays, MessageCircle };

export const Icon = ({ name, className }) => {
  const Cmp = MAP[name] ?? Zap;
  return <Cmp className={className} />;
};
